import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';
import { OtherTranslations } from '../../hooks/queries/OtherTranslations';
import { StyledFooter, StyledLinkSection, StyledExtraLines } from "../../styledComponents";
import { getLinkPrefix } from '../../utils/getLinkPrefix';
import { LogoSection } from '../';

export const Footer = () => {
    const year = new Date().getFullYear();
    const langKey = getCurrentLangKey();

    const data = OtherTranslations();
    const t = data.mb.otherTranslation.localizations.find(item => item.locale === langKey) || data.mb.otherTranslation;

    return (
        <StyledFooter>
            <div className="container">
                <StyledLinkSection>
                    <div className="block">
                        <a className="title" href="https://www.freeconferencecall.com/features">{t.footer_features}</a>
                        <div className="block_links">
                            <a href={t.footer_column1_link1}><span>{t.footer_column1_link1_label}</span></a>
                            <a href={t.footer_column1_link2}><span>{t.footer_column1_link2_label}</span></a>
                            <a href={t.footer_column1_link3}><span>{t.footer_column1_link3_label}</span></a>
                            <a href={t.footer_column1_link4}><span>{t.footer_column1_link4_label}</span></a>
                        </div>
                    </div>
                    <div className="block">
                        <a className="title" href="https://www.freeconferencecall.com/how-it-works">{t.footer_solutions}</a>
                        <div className="block_links">
                            <a href={t.footer_column2_link1}><span>{t.footer_column2_link1_label}</span></a>
                            <a href={t.footer_column2_link2}><span>{t.footer_column2_link2_label}</span></a>
                            <a href={t.footer_column2_link3}><span>{t.footer_column2_link3_label}</span></a>
                            <a href={t.footer_column2_link4}><span>{t.footer_column2_link4_label}</span></a>
                            <a href={t.footer_column2_link5}><span>{t.footer_column2_link5_label}</span></a>
                        </div>
                    </div>
                    <div className="block">
                        <Link className="title" language={langKey} to="/">{t.footer_support}</Link>
                        <div className="block_links">
                            <a href={t.footer_column3_link1}><span>{t.footer_column3_link1_label}</span></a>
                            <a href={t.footer_column3_link2}><span>{t.footer_column3_link2_label}</span></a>
                            <a href={t.footer_column3_link3}><span>{t.footer_column3_link3_label}</span></a>
                            <a href={t.footer_column3_link4}><span>{t.footer_column3_link4_label}</span></a>
                        </div>
                    </div>
                    <div className="block">
                        <a className="title" href="https://www.freeconferencecall.com/features">{t.footer_company}</a>
                        <div className="block_links">
                            <a href={t.footer_column4_link1}><span>{t.footer_column4_link1_label}</span></a>
                            <a href={t.footer_column4_link2}><span>{t.footer_column4_link2_label}</span></a>
                            <a href={t.footer_column4_link3}><span>{t.footer_column4_link3_label}</span></a>
                            <Link to={getLinkPrefix('categories', `${t.footer_column4_link4}`)} language={langKey} title={t.footer_column4_link4_label}><span>{t.footer_column4_link4_label}</span></Link>
                        </div>
                    </div>
                    <div className="block">
                        <a className="title" href="https://www.freeconferencecall.com/features">{t.footer_stay_connected}</a>
                        <div className="block_links">
                            <a href={t.footer_column5_link1}><span>{t.footer_column5_link1_label}</span></a>
                            <a href={t.footer_column5_link2}><span>{t.footer_column5_link2_label}</span></a>
                            <a href={t.footer_column5_link3}><span>{t.footer_column5_link3_label}</span></a>
                        </div>
                    </div>
                </StyledLinkSection>
                <div className="socials">
                    <LogoSection />
                </div>
                <StyledExtraLines className="small">
                    <a href="https://www.freeconferencecall.com/privacy-policy">{t.footer_privacy_policy}</a>
                    <a href="https://www.freeconferencecall.com/sitemap">{t.footer_sitemap}</a>
                    <a href="https://www.freeconferencecall.com/phone/acceptableuse">{t.footer_acceptable_use}</a>
                    <a href="https://www.freeconferencecall.com/terms-of-service">{t.footer_terms_conditions}</a>
                    <a href="https://www.freeconferencecall.com/terms-and-conditions-us-gov-agencies">{t.footer_terms_for_us_government}</a>
                    <div className="copyright">
                        <span>{`© FreeConferenceCall.com 2001-${year}, ver G `}</span>
                    </div>
                </StyledExtraLines>
            </div>
        </StyledFooter>
    )
};
